import * as propertyTypes from "../../property_types"
import { ServiceReportComponentBaseProps } from "./servicereport_base_question_metadata";

export class ServiceReportTextMetadata extends ServiceReportComponentBaseProps {
    private constraintsMetadata = new propertyTypes.ObjectListPropertyExt("Constraints", "Constraints")
        .addStateImplementation("InvalidRangeConstraint", InvalidRangeConstraint)
        .addStateImplementation("MandatoryConstraint", MandatoryConstraint)
        .addStateImplementation("StringLengthConstraint", StringLengthConstraint)
        .addStateImplementation("PatternConstraint", PatternConstraint)
        .addStateImplementation("CustomConstraint", CustomConstraint);
    public Constraints: any[];

    private templateMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.templateMetadataAll = baseMetaData.concat([this.constraintsMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.templateMetadataAll;
    }
}

export class ServiceReportMultiSelectMetadata extends ServiceReportComponentBaseProps {
    private constraintsMetadata = new propertyTypes.ObjectListPropertyExt("Constraints", "Constraints")
        .addStateImplementation("MandatoryConstraint", MandatoryConstraint)
        .addStateImplementation("CustomConstraint", CustomConstraint)
        .addStateImplementation("TriggerValueConstraint", TriggerValueConstraint);
    public Constraints: any[];

    private typeMetadata = new propertyTypes.SelectProperty("Type", "Type")
        .addOption(5, "Radio buttons")
        .addOption(6, "Check boxes")
        .addOption(11, "Pick list");
    public Type: string;

    private FilterScriptMetadata = new propertyTypes.TextPropertyBase("CR_SCRIPT_EDITOR", "FilterScript", "FilterScript");
    public FilterScript: string;

    private templateMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.templateMetadataAll = baseMetaData.concat([this.constraintsMetadata, this.typeMetadata, this.FilterScriptMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {

        return this.templateMetadataAll;
    }
}

export class ServiceReportImageMetadata extends ServiceReportComponentBaseProps {

    private imageIdMetadata = new propertyTypes.ObjectListPropertyExt("Pictures", "Documents")
        .addStateImplementation("default", ImageProps);
    public Pictures: string;

    private templateMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata().slice(3);
        this.templateMetadataAll = baseMetaData.concat([this.imageIdMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.templateMetadataAll;
    }
}

export class ReactComponentMetadata extends ServiceReportComponentBaseProps {

    private ReactComponentMetadata = new propertyTypes.ReactTemplateProperty("ReactTemplate", "React template");
    public ReactComponent: string;

    private reactMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata().slice(3);
        this.reactMetadataAll = baseMetaData.concat([this.ReactComponentMetadata]);
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.reactMetadataAll;
    };

    hasErrors(): boolean {
        const meta = this.getMetadata();

        for (let x of meta) {
            let value = this[x.ValueField];

            if (x.IsMandatory && !value) {
                return true;
            }
        }
        return false;
    }
};

class ImageProps extends propertyTypes.Serializable {
    private IdMetadata = new propertyTypes.DocumentIdProperty("Id", "Id");
    public Id: string;

    private drillDownMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.drillDownMetadata = [this.IdMetadata];
    }
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.drillDownMetadata;
    }
}

class TagsProperty extends propertyTypes.TextPropertyBase {

    constructor(valueField: string, label: string) {
        super("TAGSPROPERTY", valueField, label);
    }
}
export class ServiceReportProps extends propertyTypes.Serializable {
    private titleMetadata = new propertyTypes.NotEditableProperty("Title", "Title");
    public Title: string;

    private translatableTitleMetadata = new propertyTypes.TranslatableTextArrayProperty("TranslatableTitle", "Title", "Language", "Translation");
    public TranslatableTitle: string;

    private tagsMetadata = new TagsProperty("Tags", "tags");
    private tags: any[];

    private baseComponentMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.baseComponentMetadata = [this.titleMetadata, this.translatableTitleMetadata, this.tagsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.baseComponentMetadata;
    };

    hasErrors(): boolean {
        const meta = this.getMetadata();

        for (let x of meta) {
            let value = this[x.ValueField];

            if (x.IsMandatory && !value) {
                return true;
            }
        }
        return false;
    }
};

export class SectionProps extends propertyTypes.Serializable {
    private titleMetadata = new propertyTypes.NotEditableProperty("Title", "Title");
    public Title: string;

    private translatableTitleMetadata = new propertyTypes.TranslatableTextArrayProperty("TranslatableTitle", "Title", "Language", "Translation");
    public TranslatableTitle: string;

    private VisibilityPredicateMetadata = new propertyTypes.TextPropertyBase("CR_SCRIPT_EDITOR", "VisibilityPredicate", "Visibility script");
    public VisibilityPredicate: string;

    private baseComponentMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.baseComponentMetadata = [this.titleMetadata, this.translatableTitleMetadata, this.VisibilityPredicateMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.baseComponentMetadata;
    };

    hasErrors(): boolean {
        const meta = this.getMetadata();

        for (let x of meta) {
            let value = this[x.ValueField];

            if (x.IsMandatory && !value) {
                return true;
            }
        }
        return false;
    }
};

const SeverityMetadata = new propertyTypes.SelectProperty("Severity", "Severity")
    .addOption("0", "Warning")
    .addOption("1", "Critical Warning")
    .addOption("2", "Error");
SeverityMetadata.IsMandatory = true;
class InvalidRangeConstraint extends propertyTypes.Serializable {
    private MinMetadata = new propertyTypes.TextProperty("Min", "Min")
        .SetOnlyNumbers(true);
    public Min: string;

    private MinInclusiveMetadata = new propertyTypes.CheckBoxProperty("MinInclusive", "Min inclusive");
    public MinInclusive: boolean;

    private MaxMetadata = new propertyTypes.TextProperty("Max", "Max")
        .SetOnlyNumbers(true);
    public Max: string;

    private MaxInclusiveMetadata = new propertyTypes.CheckBoxProperty("MaxInclusive", "Max inclusive");
    public MaxInclusive: boolean;

    private MessageMetadata = new propertyTypes.TranslatableTextArrayProperty("Message", "Message", "Language", "Translation");
    public Message: string;

    private EnabledScriptMetadata = new propertyTypes.TextPropertyBase("CR_SCRIPT_EDITOR", "EnabledScript", "Enabled script");
    public EnabledScript: string;

    private drillDownMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.drillDownMetadata = [this.MinMetadata, this.MinInclusiveMetadata, this.MaxMetadata, this.MaxInclusiveMetadata, SeverityMetadata, this.MessageMetadata, this.EnabledScriptMetadata];
    }
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.drillDownMetadata;
    }
}

class MandatoryConstraint extends propertyTypes.Serializable {
    private EnabledFunctionMetadata = new propertyTypes.TemplateProperty("EnabledFunction", "Enabled function");
    public EnabledFunction: string;

    private MessageMetadata = new propertyTypes.TranslatableTextArrayProperty("Message", "Message", "Language", "Translation");
    public Message: string;

    private EnabledScriptMetadata = new propertyTypes.TextPropertyBase("CR_SCRIPT_EDITOR", "EnabledScript", "Enabled script");
    public EnabledScript: string;

    private drillDownMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.drillDownMetadata = [SeverityMetadata, this.MessageMetadata, this.EnabledScriptMetadata];
    }
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.drillDownMetadata;
    }
}

class StringLengthConstraint extends propertyTypes.Serializable {
    private MaxLengthMetadata = new propertyTypes.TextProperty("MaxLength", "MaxLength");
    public MaxLength: string;

    private MessageMetadata = new propertyTypes.TranslatableTextArrayProperty("Message", "Message", "Language", "Translation");
    public Message: string;

    private EnabledScriptMetadata = new propertyTypes.TextPropertyBase("CR_SCRIPT_EDITOR", "EnabledScript", "Enabled script");
    public EnabledScript: string;

    private drillDownMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.drillDownMetadata = [this.MaxLengthMetadata, SeverityMetadata, this.MessageMetadata, this.EnabledScriptMetadata];
    }
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.drillDownMetadata;
    }
}

class PatternConstraint extends propertyTypes.Serializable {
    private MaxLengthMetadata = new propertyTypes.TextProperty("Pattern", "Pattern");
    public MaxLength: string;

    private MessageMetadata = new propertyTypes.TranslatableTextArrayProperty("Message", "Message", "Language", "Translation");
    public Message: string;

    private EnabledScriptMetadata = new propertyTypes.TextPropertyBase("CR_SCRIPT_EDITOR", "EnabledScript", "Enabled script");
    public EnabledScript: string;

    private drillDownMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.drillDownMetadata = [this.MaxLengthMetadata, SeverityMetadata, this.MessageMetadata, this.EnabledScriptMetadata];
    }
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.drillDownMetadata;
    }
}

class TriggerValueConstraint extends propertyTypes.Serializable {
    private TriggerKeyMetadata = new propertyTypes.TextProperty("TriggerKey", "Trigger key");
    public TriggerKey: string;

    private MessageMetadata = new propertyTypes.TranslatableTextArrayProperty("Message", "Message", "Language", "Translation");
    public Message: string;

    private EnabledScriptMetadata = new propertyTypes.TextPropertyBase("CR_SCRIPT_EDITOR", "EnabledScript", "Enabled script");
    public EnabledScript: string;

    private CustomScriptIdMetadata = new propertyTypes.NotEditableProperty("CustomScriptId", "Custom script id");
    public CustomScriptId: string;

    private ampelstatusMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.CustomScriptId = "fsm_triggervalue_constraint";
        this.ampelstatusMetadata = [this.TriggerKeyMetadata, SeverityMetadata, this.MessageMetadata, this.EnabledScriptMetadata, this.CustomScriptIdMetadata];
    }
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.ampelstatusMetadata;
    }
}

class CustomConstraint extends propertyTypes.Serializable {

    private ValidationScriptMetadata = new propertyTypes.TextPropertyBase("CR_SCRIPT_EDITOR", "ValidationScript", "Validation script");
    public ValidationScript: string;

    private EnabledScriptMetadata = new propertyTypes.TextPropertyBase("CR_SCRIPT_EDITOR", "EnabledScript", "Enabled script");
    public EnabledScript: string;

    private MessageMetadata = new propertyTypes.TranslatableTextArrayProperty("Message", "Message", "Language", "Translation");
    public Message: string;

    private drillDownMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.drillDownMetadata = [this.ValidationScriptMetadata, SeverityMetadata, this.MessageMetadata, this.EnabledScriptMetadata];
    }
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.drillDownMetadata;
    }
}